import React from 'react';
import styled from 'styled-components';
import { Text } from '../../../../components';
import { COLORS, device, FONTS } from '../../../../constants';

interface DivProps extends React.HTMLProps<HTMLDivElement> {
  stepText: string;
  stepNr: string;
}

export const StepElement: React.FC<DivProps> = ({
  stepNr,
  stepText,
  children,
  ...props
}) => {
  return (
    <ElementStyle {...props}>
      <StepWrapper>
        <StepNumberWrapper>
          <Text
            size={96}
            weight={700}
            color={COLORS.STEP}
            text={stepNr}
            lineHeight={96}
            fontFamily={FONTS.TITLE}
          />
        </StepNumberWrapper>
      </StepWrapper>
      <Text
        size={24}
        weight={600}
        color={COLORS.RED_LINE}
        text={stepText}
        lineHeight={36}
        wrap="nowrap"
      />
    </ElementStyle>
  );
};

const ElementStyle = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 14px;
  max-width: 200px;
  @media screen and ${device.xl} {
    max-width: 150px;
    > h4 {
      font-size: 18px;
    }
  }
  @media screen and ${device.md} {
    max-width: 100px;
    > h4 {
      font-size: 15px;
    }
  }
  @media screen and ${device.sm} {
    flex-direction: row;
    align-items: center;
    max-width: none;
    gap: 30px;
    > h4 {
      font-size: 20px;
    }
  }
`;

const StepWrapper = styled.div`
  height: 115px;
  position: relative;
  @media screen and ${device.xl} {
    height: 80px;
  }
  @media screen and ${device.md} {
    height: 50px;
  }
  @media screen and ${device.sm} {
    height: auto;
  }
`;

const StepNumberWrapper = styled.div`
  position: relative;
  &::after {
    content: '';
    position: absolute;
    height: 20px;
    width: 20px;
    background-color: ${COLORS.FOOTER_BACKGROUND};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
  }
  @media screen and ${device.xl} {
    > h4 {
      font-size: 70px;
    }
  }
  @media screen and ${device.md} {
    > h4 {
      font-size: 40px;
      line-height: 48px;
    }
    &::after {
      height: 14px;
      width: 14px;
    }
  }
  @media screen and ${device.sm} {
    > h4 {
      min-width: 100px;
      font-size: 60px;
    }
    &::after {
      height: 20px;
      width: 20px;
    }
  }
`;
